// import "./algemene";
// import "./header";
// import "./filter-popup";
// import "./addonsPopup";
import "./addonsDetails";
// import "./checkout";
// import "./thankyou";
